import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * this component is a placeholder for later login and registration componet
 */
@Component({
    selector: 'app-login',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="login-container">
            <button class="login-button" (click)="login()">
                Login
            </button>
        </div>
    `,
    styles: [`
        .login-container {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: calc(100vh - 64px);
        }

        .login-button {
            padding: 12px 24px;
            font-size: 16px;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            transition: background-color 0.2s;
        }

        .login-button:hover {
            background-color: #0056b3;
        }
    `]
})
export class LoginComponent {
    constructor() {}

    login() {
        this.navigateTo('/api/login');
    }

    navigateTo(url: string) {
        window.location.href = url;
    }
}
